<template>
  <div class="w-full">
    <b>{{ question.text }}</b>
    <div v-if="type == 'comment'" class="mb-2">
      <div v-if="!isEditable">{{ question.answer }}</div>
      <vs-textarea
        v-else
        v-model="question.answer"
        class="meetingQuestionTextareaContainer"
        height="110px"
      ></vs-textarea>
    </div>
    <div v-else-if="type == 'integerRating'" class="mb-2">
      <vs-slider
        v-model="question.answer"
        :min="question.minValue"
        :max="question.maxValue"
        :disabled="!isEditable"
      ></vs-slider>
    </div>
  </div>
</template>

<script>
export default {
  props: ["question", "isEditable"],
  computed: {
    type() {
      return this.question.type;
    },
  },
};
</script>

<style lang="scss">
.meetingQuestionTextareaContainer textarea {
  height: 100%;
  resize: none;

  &:focus {
    resize: none !important;
  }
}
</style>

